























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { AxiosError } from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import Heading from '../components/Heading.vue';
import Errors from '../components/Errors.vue';
import { RegisterCredentials } from '../store/authStore.d';
import retrieveErrorsFromResponse from '../helpers/retrieveErrorsFromResponse';

const registerCredentials: RegisterCredentials = {
  first_name: '', // eslint-disable-line @typescript-eslint/camelcase
  last_name: '', // eslint-disable-line @typescript-eslint/camelcase
  email: '',
  'g-recaptcha-response': '',
};

@Component({
  name: 'Register',

  components: {
    Heading,
    Errors,
    VueRecaptcha,
  },
})
export default class Register extends Vue {
  formInput = registerCredentials;

  errors: Array<string> = [];

  recaptchaKey = '';

  $refs!: {
    invisibleRecaptcha: VueRecaptcha;
  }

  created() {
    this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
  }

  validate() {
    if (!this.formInput.email) {
      this.errors.push('Voer een e-mailadres in');
    }

    if (!this.formInput.first_name) {
      this.errors.push('Voer een voornaam in');
    }

    if (!this.formInput.last_name) {
      this.errors.push('Voer een achternaam in');
    }

    return !this.errors.length;
  }

  get registerLoadingState() {
    return this.$store.getters.registerLoadingState;
  }

  onRecaptchaVerify(response: string) {
    this.formInput['g-recaptcha-response'] = response;
    this.$refs.invisibleRecaptcha.reset();

    this.errors = [];

    if (!this.validate()) {
      return;
    }

    this.$store
      .dispatch('register', this.formInput)
      .then(() => {
        this.$store.commit('setFlashMessage', [
          'We hebben een account aangemaakt, binnen enkele ogenblikken ontvang je een mail.',
          'success',
        ]);

        this.$router.push({ name: 'Login' });
      })
      .catch((err: AxiosError) => {
        // eslint-disable-next-line no-console
        console.log(err);

        if (!err.response) {
          return;
        }

        this.errors = retrieveErrorsFromResponse(err.response);
      });
  }

  onRecaptchaExpired() {
    this.$refs.invisibleRecaptcha.reset();
    this.formInput['g-recaptcha-response'] = '';
  }

  register() {
    this.$refs.invisibleRecaptcha.execute();
  }
}
